/** Interface strings of the operator console shell, user page and master-detail. */
export const adminConsoleMessages = {
  "admin.users.pick": {
    ru: "Выберите пользователя в списке.",
    en: "Select a user from the list.",
  },
  "admin.users.piiHidden": {
    ru: "Имена и Telegram ID скрыты: нужно право users.pii.read.",
    en: "Names and Telegram IDs hidden: needs permission (users.pii.read).",
  },
  "admin.users.meta.requests": { ru: "запр.", en: "req" },
  "admin.users.noPlan": { ru: "без тарифа", en: "no plan" },
  "admin.users.header.telegram": { ru: "Telegram", en: "Telegram" },
  "admin.users.header.id": { ru: "ID", en: "ID" },
  "admin.users.tabs.label": { ru: "Разделы пользователя", en: "User sections" },
  "admin.users.tab.profile": { ru: "Профиль", en: "Profile" },
  "admin.users.tab.activity": { ru: "Активность", en: "Activity" },
  "admin.users.tab.storage": { ru: "Хранилище", en: "Storage" },
  "admin.users.tab.billing": { ru: "Оплата", en: "Billing" },
  "admin.users.tab.identities": { ru: "Аккаунты", en: "Identities" },
  "admin.users.tab.logs": { ru: "Логи", en: "Logs" },
  "admin.users.openInLogs": { ru: "Открыть в Логах", en: "Open in Logs" },
  "admin.logs.pick": {
    ru: "Выберите вызов в списке.",
    en: "Select a call from the list.",
  },
  "admin.logs.openUser": { ru: "Открыть пользователя", en: "Open user" },
  "admin.logs.filteredByUser": {
    ru: "Фильтр по пользователю",
    en: "Filtered by user",
  },
} as const;
